import IconWrapper from './icon-wrapper';

const normalIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 16C16.5523 16 17 15.5523 17 15V8C17 7.44772 16.5523 7 16 7H11.4367C10.2496 7 9.12384 6.47271 8.36387 5.56074L7.3631 4.35982C7.1731 4.13182 6.89165 4 6.59487 4H4C3.44772 4 3 4.44772 3 5L3 15C3 15.5523 3.44772 16 4 16H16ZM3 2C1.89543 2 1 2.89543 1 4V16C1 17.1046 1.89543 18 3 18H17C18.1046 18 19 17.1046 19 16V7C19 5.89543 18.1046 5 17 5H11.4367C10.8432 5 10.2803 4.73635 9.90031 4.28037L8.59969 2.71963C8.21971 2.26365 7.65681 2 7.06325 2H3Z"
      fill="#595959"
    />
    <path
      d="M5 12C5 11.4477 5.44772 11 6 11H10C10.5523 11 11 11.4477 11 12V13C11 13.5523 10.5523 14 10 14H6C5.44772 14 5 13.5523 5 13V12Z"
      fill="url(#paint0_linear_1517_7885)"
    />
    <defs>
      <linearGradient id="paint0_linear_1517_7885" x1="5" y1="11" x2="5" y2="14" gradientUnits="userSpaceOnUse">
        <stop stopColor="#B9B9B9" />
        <stop offset="1" stopColor="#7B7B7B" stopOpacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
);

const activedIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 16C16.5523 16 17 15.5523 17 15V8C17 7.44772 16.5523 7 16 7H11.4367C10.2496 7 9.12384 6.47271 8.36387 5.56074L7.3631 4.35982C7.1731 4.13182 6.89165 4 6.59487 4H4C3.44772 4 3 4.44772 3 5L3 15C3 15.5523 3.44772 16 4 16H16ZM3 2C1.89543 2 1 2.89543 1 4V16C1 17.1046 1.89543 18 3 18H17C18.1046 18 19 17.1046 19 16V7C19 5.89543 18.1046 5 17 5H11.4367C10.8432 5 10.2803 4.73635 9.90031 4.28037L8.59969 2.71963C8.21971 2.26365 7.65681 2 7.06325 2H3Z"
      fill="#2D64FF"
    />
    <path
      d="M5 12C5 11.4477 5.44772 11 6 11H10C10.5523 11 11 11.4477 11 12V13C11 13.5523 10.5523 14 10 14H6C5.44772 14 5 13.5523 5 13V12Z"
      fill="url(#paint0_linear_1517_7662)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1517_7662"
        x1="4.2996"
        y1="10.7622"
        x2="4.05885"
        y2="14.5083"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B3EE" />
        <stop offset="1" stopColor="#2BCAFF" stopOpacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
);

export default function IconDaily() {
  return <IconWrapper normalIcon={normalIcon} activedIcon={activedIcon} />;
}
